import KmxCloseFilled from '@kmx/mui-icons/KmxCloseFilled';
import DialogTitle, { type DialogTitleProps } from '@mui/material/DialogTitle';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

const StyledDialogTitle = styled(DialogTitle)<DialogTitleProps>(() => ({
  paddingRight: '3.5rem',
}));

const StyledIconButton = styled(IconButton)<IconButtonProps>(() => ({
  position: 'absolute',
  right: '0.5rem',
  top: '0.5rem',
}));

type DialogTitleWithCloseButtonProps = Omit<DialogTitleProps, 'onClick'> & {
  onClose: NonNullable<IconButtonProps['onClick']>;
};

export default function DialogTitleWithCloseButton({
  children,
  onClose,
  ...dialogTitleProps
}: DialogTitleWithCloseButtonProps) {
  return (
    <>
      <StyledDialogTitle {...dialogTitleProps}>{children}</StyledDialogTitle>
      <StyledIconButton aria-label="Close" onClick={onClose}>
        <KmxCloseFilled fontSize="inherit" />
      </StyledIconButton>
    </>
  );
}
